import { render, staticRenderFns } from "./permission-checkboxes.vue?vue&type=template&id=495f3e48&"
import script from "./permission-checkboxes.vue?vue&type=script&lang=js&"
export * from "./permission-checkboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495f3e48')) {
      api.createRecord('495f3e48', component.options)
    } else {
      api.reload('495f3e48', component.options)
    }
    module.hot.accept("./permission-checkboxes.vue?vue&type=template&id=495f3e48&", function () {
      api.rerender('495f3e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/rbac/permission-checkboxes.vue"
export default component.exports